// Generated by CoffeeScript 1.12.2
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('models/survey',['require','backbone','etc/definitions'],function(require) {
  var Model, Survey, apiUri;
  Model = require('backbone').Model;
  apiUri = require('etc/definitions').apiUri;
  return Survey = (function(superClass) {
    extend(Survey, superClass);

    function Survey() {
      return Survey.__super__.constructor.apply(this, arguments);
    }

    Survey.prototype.idAttribute = "_id";

    Survey.prototype.urlRoot = function() {
      return GLOBALS.uris.api + "/survey";
    };

    Survey.prototype.defaults = {
      branding: {
        logo: null,
        url: "https://surveyplanet.com"
      },
      theme: null,
      success: {},
      welcome: {}
    };

    Survey.prototype.parse = function(response, options) {
      return response.data;
    };

    Survey.prototype.initialize = function() {};

    return Survey;

  })(Model);
});

